// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e136fcb5","166":"e396cabf","267":"a37c5f61","375":"efa808a4","536":"96fedcce","609":"065a2a3a","693":"b2819c8a","717":"34a7b674"}[chunkId] + ".chunk.js";
};